var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart40Filled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M28.88 1.7c5.304 0 9.62 4.321 9.62 9.68 0 6.5-3.001 11.71-6.778 15.58-3.795 3.888-8.281 6.323-10.966 7.24l-.015.006c-.13.046-.398.094-.741.094s-.612-.048-.741-.094l-.015-.006c-2.685-.917-7.17-3.352-10.966-7.24C4.501 23.09 1.5 17.88 1.5 11.38c0-5.359 4.316-9.68 9.62-9.68 3.143 0 5.925 1.517 7.676 3.874a1.5 1.5 0 0 0 2.408 0A9.56 9.56 0 0 1 28.88 1.7"
})));
export default SvgHeart40Filled;